export default __webpack_public_path__ + "static/media/interoperability-station-logo.f1d5149a.svg";